import React from 'react'

export default function TeamSliderCard({img,name,designation}) {
  return (
    <>
      <div className="teamSliderCard">
        <figure>
            <img src={img} alt="" />
        </figure>
        <i class=" fa-regular fa-quote-right"></i>
        <p>Lorem ipsum dolor sit amet, ectetur adipiscing elit. Phasellus vel erat ces, commodo lectus eu, finibus diam. m ipsum dolor sit amet, ectetur.</p>
        <h3>{name}</h3>
        <h4>{designation}</h4>
      </div>
    </>
  )
}
